import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { TabContent, TabPane } from 'reactstrap';

import { fetchAcceptedTermsOfService } from '../../../actions/Shares';

import { APIfetchAcceptedTermsOfService } from '../../../api/Shares';

import CollectedDetails from './CollectedDetails';
import TermsOfService from '../TermsOfService/TermsOfService';

const ShareDetailsTabContent = ({ activeTab, shareUuid }) => {
  const intl = useIntl();

  return (
    <TabContent activeTab={activeTab} className="settings-tab-content">
      <TabPane tabId="collected-details">
        <CollectedDetails
          shareUuid={shareUuid}
        />
      </TabPane>
      <TabPane tabId="tos">
        <TermsOfService
          entityUuid={shareUuid}
          subtitle={intl.formatMessage({ defaultMessage: 'Browse accepted terms of service on this share link' })}
          fetchAcceptedTermsOfService={fetchAcceptedTermsOfService}
          APIfetchAcceptedTermsOfService={APIfetchAcceptedTermsOfService}
        />
      </TabPane>
    </TabContent>
  );
};

ShareDetailsTabContent.propTypes = {
  activeTab: PropTypes.string.isRequired,
  shareUuid: PropTypes.string.isRequired,
};

export default ShareDetailsTabContent;
